export default __webpack_public_path__ + "static/gary2-efb3aed3439660602a280245174271c8.jpg";